import Api from '../utils/Api';
import Config from '../config/Config';

class IndicadorCurse {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntity({ name: 'credito' });
  }

  indicadorCurse(token) {
    const config = { headers: { 'token': token } };
    return this.api.endpoints.credito
      .getWithParams('indicadorcurse',`consultar=false`, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

export default new IndicadorCurse;